export default "__VITE_ASSET__Dq3i2bOl__"